import { Operation } from 'flow/service/changelog/types';
import type { HistoryAction } from 'flow/service/history/constants';
import { historyAction } from 'flow/service/history/constants';

export const UI_EFFECT_DEBOUNCE_MS = 250;
export const DRAWER_DEBOUNCE_MS = 100;

export const historyActionTextMap: Record<HistoryAction, string> = {
  [historyAction.undo]: 'Undo',
  [historyAction.redo]: 'Redo',
};

export const undoUiEffectMap: Record<Operation, Operation> = {
  [Operation.Add]: Operation.Remove,
  [Operation.Modify]: Operation.Modify,
  [Operation.Remove]: Operation.Add,
};

export const operationTextMap: Record<Operation, string> = {
  [Operation.Add]: 'add',
  [Operation.Modify]: 'update',
  [Operation.Remove]: 'delete',
};
